module.exports = __webpack_public_path__ + "static/media/icon-badge.490aff0d.svg";